export const ALL_BEAUTY_SECTION = {
  label: 'All Beauty',
  url: 'https://www.modaoperandi.com/beauty/products/all',
  styleProps: {
    isBold: true,
    hasDividerAfter: false,
    __typename: 'RefreshedMobileNavStyleProps'
  },
  mainCategoryItems: [
    {
      subItems: [
        {
          label: 'CATEGORIES',
          url: null,
          centerTitle: false,
          listLinks: [
            {
              label: 'Skincare',
              url: 'https://www.modaoperandi.com/beauty/products/skincare',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Cleansers',
              url: 'https://www.modaoperandi.com/beauty/products/skincare/cleansers',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Serums',
              url: 'https://www.modaoperandi.com/beauty/products/skincare/treatments',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Moisturizers',
              url: 'https://www.modaoperandi.com/beauty/products/skincare/moisturizers/moisturizers',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Masks',
              url: 'https://www.modaoperandi.com/beauty/products/skincare/masks',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Makeup',
              url: 'https://www.modaoperandi.com/beauty/products/makeup',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Lip',
              url: 'https://www.modaoperandi.com/beauty/products/makeup/lip',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Face',
              url: 'https://www.modaoperandi.com/beauty/products/makeup/face',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Eyes',
              url: 'https://www.modaoperandi.com/beauty/products/makeup/eyes',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Hair',
              url: 'https://www.modaoperandi.com/beauty/products/hair',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Fragrance',
              url: 'https://www.modaoperandi.com/beauty/products/all?category=fragrance',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            },
            {
              label: 'Body',
              url: 'https://www.modaoperandi.com/beauty/products/body',
              isHighlighter: false,
              __typename: 'MobileNavListLink'
            }
          ],
          __typename: 'MobileNavSubItem'
        }
      ],
      __typename: 'MobileNavMainCategoryItem'
    }
  ],
  __typename: 'MobileNavMainCategory'
};
